import { Component, OnInit, ViewChild, OnDestroy, Input, Output, EventEmitter, OnChanges, SimpleChanges, SimpleChange, ElementRef, NgZone} from '@angular/core';
import { UtilService } from '../service/util.service';

@Component({
  selector: 'app-view-journey-detail',
  templateUrl: './view-journey-detail.component.html',
  styleUrls: ['./view-journey-detail.component.scss']
})
export class ViewJourneyDetailComponent implements OnInit {
  @ViewChild('gmap') gmap: ElementRef;
  @Input() journeyDetail;
  
  @Output() closeEmitter: EventEmitter<any> = new EventEmitter<any>();

  
  map: google.maps.Map;
  directionsService: any;
  locations: Array<Location> = new Array();
  setupRouteModal: any;
  routesForLocation: any;
  directionsDisplayList: Array<any> = new Array();
  markerList: Array<any> = new Array();
  minimumCalanderDate = new Date();
  vehicle: { "vin": any; "make": any; "model": any; "year": any; };
  origin: any;
  destination: any;
  directionsDisplay: google.maps.DirectionsRenderer;

  constructor(private utilService: UtilService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.init();
  }

  ngAfterViewInit() {
    console.log("Before Delay ViewInit is : ", this.gmap);
    setTimeout(() => {
      if (this.gmap != undefined) {
        console.log("After Frist Delay ViewInit is : ", this.gmap);
        this.initMap();
      } else {
        setTimeout(() => {
          if (this.gmap != undefined) {
            console.log("After Second Delay ViewInit is : ", this.gmap);
            this.initMap();
          }
        }, 1500);
      }
    }, 1500);
  }
  
  init() {
    this.utilService.showSpinner();
    console.log("Journey data : ", this.journeyDetail);
    this.getVehicleDetails();
    this.origin = this.journeyDetail.startLocation.coordinate;
    this.destination = this.journeyDetail.endLocation.coordinate;
  }
  
  getVehicleDetails() {
    this.vehicle = {
      "vin" : this.journeyDetail.vin,
      "make" : this.journeyDetail.make,
      "model" : this.journeyDetail.model,
      "year" : this.journeyDetail.year
    };
    
  }

  closeClicked() {
    this.closeEmitter.emit(JSON.parse(JSON.stringify(this.journeyDetail)));
  }


  /******* google maps *************/

  initMap() {
    var CENTER_LAT_LNG = new google.maps.LatLng(35.9411,-86.8141);
    var mapOptions = {
      zoom: 7,
      center: CENTER_LAT_LNG,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
   // var map = new google.maps.Map(document.getElementById("map"), MapOptions);
    this.map = new google.maps.Map(document.getElementById("map"), mapOptions);

    this.directionsService = new google.maps.DirectionsService();
    this.directionsDisplay = new google.maps.DirectionsRenderer;
    this.directionsDisplay.setMap(this.map);
   // var marker = new google.maps.Marker({position: new google.maps.LatLng(35.9411,-86.8141), map:this.map});
    this.calculateAndDisplayRoute();
    //return map;
  }

  calculateAndDisplayRoute = function () {
    console.log("Inside Route Display");
    console.log(" lat : " + this.origin + " lon : " + this.destination);
    let that = this;
    this.directionsService.route({
      // origin: new google.maps.LatLng(42.9687369792, -88.0488020833),
      // destination: new google.maps.LatLng(42.9687803819, -88.0486545139),
      // origin: "st louis, mo",
      // destination: "chicago, il",
      origin: new google.maps.LatLng(that.origin.latitude, that.origin.longitude),
      destination: new google.maps.LatLng(that.destination.latitude, that.destination.longitude),
      travelMode: google.maps.TravelMode.DRIVING
    }, function (response, status) {
      if (status === 'OK') {
        console.log("Direction service response : ", response);
        that.directionsDisplay.setDirections(response);
        that.utilService.hideSpinner();
      } else {
        console.log('Directions request failed due to ', status);
        that.utilService.hideSpinner();
      }
    });
  }

  markerPlot(lat, lon, title, color) {
    console.log("request to add marker at::", lat, lon, title, color);
    var latlng = new google.maps.LatLng(lat, lon);
    var marker = new google.maps.Marker({
      title: title,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        strokeColor: color,
        scale: 5
      },
      map: this.map,
      position: latlng
    });

    this.markerList.push(marker);
  }

  currentLocationMarkerPlot(lat, lon, title, color) {
    console.log("request to add marker at::", lat, lon, title, color);
    var latlng = new google.maps.LatLng(lat, lon);
    var marker = new google.maps.Marker({
      title: title,
      icon: {
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        strokeColor: color,
        scale: 3
      },
      map: this.map,
      position: latlng
    });

    this.markerList.push(marker);
  }

  clearMarkers() {
    for (var i = 0; i < this.markerList.length; i++) {
      this.markerList[i].setMap(null);
    }
    this.markerList = [];
  }

  // calculateAndDisplayRoute(startLat, startLong, endLat, endLong, color, lineStroke, iconStroke) {
  //   console.log("calculate line called::", startLat, startLong, endLat, endLong, color, lineStroke, iconStroke);
  //   var directionsDisplay = new google.maps.DirectionsRenderer({
  //     suppressMarkers: true,
  //     polylineOptions: {
  //       strokeColor: color,
  //       strokeOpacity: lineStroke,
  //       icons: [{
  //         icon: {
  //           path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
  //           strokeColor: color,
  //           strokeOpacity: iconStroke,
  //           scale: 1.5
  //         },
  //         repeat: '20px'
  //       }
  //       ]
  //     }
  //   });
  //   directionsDisplay.setMap(this.map);
  //   let that = this;
  //   this.directionsService.route({
  //     origin: new google.maps.LatLng(startLat, startLong),
  //     destination: new google.maps.LatLng(endLat, endLong),
  //     travelMode: google.maps.TravelMode.DRIVING
  //   }, function (response, status) {
  //     if (status === 'OK') {
  //       directionsDisplay.setDirections(response);
  //       that.directionsDisplayList.push(directionsDisplay);
  //     } else {
  //       window.alert('Directions request failed due to ' + status);
  //     }
  //   });
  // }
}
